import axiosInstance from "./axiosInstance";

export const markVideoCompleted = async ({
  userId,
  courseId,
  videoId,
}) => {
  return axiosInstance.post(`/course/progress/complete-video`, {
    userId,
    courseId,
    videoId,
  });
};

export const initializeCourseProgress = async ({
  userId,
  courseId,
  videoIds,
}) => {
  return axiosInstance.post(`/course/progress/initialize`, {
    userId,
    courseId,
    videoIds,
  });
};

export const getCourseProgress = async ({
  userId,
  courseId,
}) => {
  return axiosInstance.get(
    `course/progress/${userId}/${courseId}`
  );
};
